import { render, staticRenderFns } from "./LessonFavoriteCard.vue?vue&type=template&id=3f291fd6&scoped=true&"
import script from "./LessonFavoriteCard.vue?vue&type=script&lang=js&"
export * from "./LessonFavoriteCard.vue?vue&type=script&lang=js&"
import style0 from "./LessonFavoriteCard.vue?vue&type=style&index=0&id=3f291fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f291fd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
